import Image from 'next/image';

import { Section, SectionHeader } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';

const servicesData = [
  {
    description: 'ballrooms, rooftops, museums, beaches, warehouses',
    icon: 'venues.svg',
    title: 'Venues'
  },
  {
    description: 'luxury banquets, live stations, specialty diets',
    icon: 'catering.svg',
    title: 'Catering'
  },
  {
    description: 'themes, floral, brand builds, immersive sets',
    icon: 'decor.svg',
    title: 'Décor & Experiences'
  },
  {
    description: 'AV, staging, truss, LED walls, furniture',
    icon: 'equipment.svg',
    title: 'Equipment Rental'
  },
  {
    description: 'MCs, musicians, DJs, performers',
    icon: 'artists.svg',
    title: 'Artists & Entertainment'
  },
  {
    description: 'hosts, promoters, technical crews',
    icon: 'event-manpower.svg',
    title: 'Event Manpower'
  },
  {
    description: 'Registration, apps, analytics, AR/VR',
    icon: 'event-technology.svg',
    title: 'Event Technology'
  }
];

const EventSupplyNetwork = () => (
  <>
    <Section>
      <SectionHeader
        text="UAE's Largest"
        gradientText='Event Supply Network'
        description='A single partner for every service'
      />

      <div className='flex flex-wrap md:justify-center -mx-3 md:-mx-4'>
        {servicesData.map((service, index) => (
          <div
            key={index}
            className='w-1/2 md:w-1/3 lg:w-1/4 px-3 md:px-4 mb-6 md:mb-8'
          >
            <div className='bg-white rounded-xl border border-pink-100 p-6 flex flex-col h-full transition-all duration-300 ease-in-out hover:shadow-xl hover:border-pink-200 hover:-translate-y-1'>
              <div className='w-10 h-10 relative md:mb-4 mb-2'>
                <Image
                  alt={`${service.title} icon`}
                  fill
                  style={{ objectFit: 'contain' }}
                  src={`${staticMediaStoreBaseURL}/about-hafla/event-supply-network/${service.icon}`}
                />
              </div>
              <div className='text-base md:text-lg font-bold bg-control bg-clip-text text-transparent mb-2'>
                {service.title}
              </div>
              <div className='text-xs md:text-sm text-gray-500 flex-grow'>
                {service.description}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className='mt-10'>
        <div className='text-center p-8 border border-brand rounded-xl bg-white shadow-sm'>
          <div className='text-base sm:text-lg text-brand leading-relaxed'>
            This breadth delivers faster quotes, better fits, and reliable
            outcomes. Our integrated marketplace includes{' '}
            <strong className='font-bold text-brand'>
              3,200+ vetted partners
            </strong>{' '}
            and{' '}
            <strong className='font-bold text-brand'>
              300+ premium venues
            </strong>
            —a network effect that keeps quality high and pricing competitive.
          </div>
        </div>
      </div>
    </Section>
    <div className='border-t border-pink-100 container mx-auto' />
  </>
);

export default EventSupplyNetwork;
